import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

const LAYOUT_BUTTON_CONTAINER_PADDING = 2;
const containerRadius = layout.measurements.spacing025;
export const LayoutButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${LAYOUT_BUTTON_CONTAINER_PADDING}px;
  background: ${p => p.theme.bg.tertiary};
  border-radius: ${containerRadius};
`;

type LayoutButtonProps = {
  active: boolean;
  width?: string;
  height?: string;
};

export const LayoutButton = styled.button<LayoutButtonProps>(
  props => css`
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    cursor: pointer;
    position: relative;
    padding: 6px;
    color: ${props.active
      ? props.theme.icons.primary
      : props.theme.icons.secondary};
    background: ${props.active ? props.theme.bg.primary : 'none'};
    border-radius: calc(${containerRadius} - 1px);
    &:hover {
      color: ${p => p.theme.icons.callToActionHover};
    }
  `
);
